import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { MostPopularService } from './most-popular.service';
import { LOCALE_ID } from '@angular/core';

@Component({
    selector: 'app-most-popular',
    templateUrl: './most-popular.component.html',
    styleUrls: ['./most-popular.component.scss'],
    providers: [{provide: LOCALE_ID, useValue: 'fr' }],
})
export class MostPopularComponent implements OnInit {

    public data: any;

    constructor(
		private content: MostPopularService
    ) {
        this.content.getData().subscribe((data: any) => {
            this.data = data.data;
        });
    }

    ngOnInit(): void {
    }

    featuredSlides: OwlOptions = {
		items: 1,
		nav: true,
		margin: 25,
		loop: true,
		dots: false,
		autoplay: false,
		smartSpeed: 500,
		autoplayHoverPause: true,
		navText: [
			"<i class='ri-arrow-left-s-line'></i>",
			"<i class='ri-arrow-right-s-line'></i>"
		]
    }

}